<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Double OVR Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Double OVR Report",
      items: [
        {
          text: "Home",
        },
         {
          text: "Reports",
        },
        {
          text: "Double OVR Report",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>